import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import useFacebookPixel from './hooks/useFacebookPixel';

const About = lazy(() => import('./components/About'));
const Contact = lazy(() => import('./components/Contact'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const BlogPost = lazy(() => import('./components/BlogPost'));

const PixelRouteListener = ({ pixelId }) => {
  const location = useLocation();
  const { trackPageView } = useFacebookPixel(pixelId);

  useEffect(() => {
    trackPageView();
  }, [location.pathname, trackPageView]);

  return null;
};

function App() {

  return (
    <Router basename="/">
      <PixelRouteListener pixelId="945486977414252" />
      <Header />
      <Suspense fallback={<div className="page-loading">Loading...</div>}>
        <Switch>
          {/* Redirect from root path to /about */}
          <Redirect exact from="/" to="/about" />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/blog/:postName" component={BlogPost} />
          {/* Fallback for unmatched routes */}
          <Redirect to="/about" />
        </Switch>
      </Suspense>
      <Footer />
    </Router>
  );
}

export default App;
